import type { StationeryProduct } from '@shared/utils/print-price/types';
import type { AttributeReader } from '../state/attributeReader.types';
import { readTaylorAttributes } from './taylor.readers';

// Paper only: a digital PDP template has no `digitalCustomizations` to read.
export const readProductAttributes = (product: StationeryProduct, mappingFunction: string, themeId: string): AttributeReader[] => {
  if (mappingFunction !== 'taylormap') {
    return [];
  }
  const productAttributeIds = product.attributes.map(a => a.attributeId);
  return readTaylorAttributes(product, themeId).filter(reader => productAttributeIds.includes(reader.productAttributeId));
};
